import React from "react";
import { Stack } from "@mui/material";
import { useFieldArray } from "react-hook-form";

import ReworkStationTableHeader from "./ReworkStationTableHeader";
import ReworkStationTableBody from "./ReworkStationTableBody";
import ReworkStationTableAddRow from "./ReworkStationTableAddRow";

export const ReworkStationTable = () => {
  const fieldArrayOptions = useFieldArray({
    name: "stations",
  });
  const { append, fields, remove, move } = fieldArrayOptions;

  const handleAdd = (defaultValues = {}) =>
    append({
      stationId: null,
      ...defaultValues,
    });

  const props = { handleAdd, remove, move, fields };

  return (
    <Stack overflowX="auto" width="100%" maxWidth="630px">
      <ReworkStationTableHeader />
      <ReworkStationTableBody {...props} />
      <ReworkStationTableAddRow handleAdd={handleAdd} />
    </Stack>
  );
};

export default ReworkStationTable;
